import scanner from "@/components/Common/BarcodeScanner/BarcodeScanner.vue";

const BarcodeScanner = {
  install: function (Vue) {
    Vue.component('barcodeScanner', scanner);
  }
}
export default BarcodeScanner;